const { gql } = require('graphql-tag');
var _parent = {};

var users = {
  init: p => (_parent = p),

  getOrgOfUser: async (customerId) => {
    const GET_ORG_OF_USER = gql`
        query getOrgOfUser($customerId: bigint!) {
            customers(where: {id: {_eq: $customerId}}) {
                    organization_id
                }
        }`;

    if (!customerId) {
      return null;
    }
    const response = await _parent.gql.mutation(GET_ORG_OF_USER, { customerId });
    if (response && response.data && response.data.length > 0) {
      return response.data[0].organization_id;
    }
    return null;
  },

  refreshUserClaims: async (userId) => {
    let affectedRows = 0;
    const REFRESH_USER_CLAIMS = gql`
      mutation refreshUserClaims($userId: bigint!) {
          update_users(where: {id: {_eq: $userId}}, _set: {updated_at: "NOW()"}) {
              affected_rows
              returning {
                  id
                  display_name
                  updated_at
              }
          }
      }`;

    if (!userId) {
      return affectedRows;
    }
    const response = await _parent.gql.mutation(REFRESH_USER_CLAIMS, { userId });
    if (response) {
      affectedRows = response.affected_rows;
    }
    return affectedRows
  },

  
  /**
   * Find which region a location belongs to
   *
   * @param {Array} customerIds array of customer ids in an organization
   * @param {bigint} userId id of the user receiving permissions
   * @returns {number} number of affected rows returned
   *
   */
  upsertAllowedCustomers: async (customerIds = [], userId = null) => {
    let affectedRows = 0;

    const UPSERT_ALLOWED_CUSTOMERS = gql`
      mutation user_events_upsertAllowedCustomers($allowedCustomersObj: [usertocustomers_insert_input!]!) {
        insert_usertocustomers(
          objects: $allowedCustomersObj
          on_conflict: { constraint: usertocustomers_user_id_customer_id_key, update_columns: [] }
        ) {
          affected_rows
          returning {
            user_id
            customer_id
          }
        }

      }
    `;

    if (userId && customerIds && customerIds.length > 0) {
      const allowedCustomersObj = customerIds.map(c => {
        return {
          customer_id: c,
          user_id: userId,
          updated_at: 'now()',
          updated_by: 'system',
          created_at: 'now()',
          created_by: 'system',
        };
      });

      if (allowedCustomersObj) {
        const allowedCustomersRes = await _parent.gql.mutation(UPSERT_ALLOWED_CUSTOMERS, { allowedCustomersObj });
        if (allowedCustomersRes) {
          affectedRows = allowedCustomersRes.affected_rows;
        }
      }
    }
    return affectedRows;
  },

  getOrganizationUsersByCustomerIds: async (customerIds = []) => {
    const GET_USERS_BY_ORG = gql`
      query getUsersByOrg($customerIds: [bigint!]!) {
        userToCustomers: usertocustomers(where: {_and: [{ customer_id: { _in: $customerIds } }, {user: {default_role: {_ilike: "%dealer%"}}}]}) {
          user_id
          user {
            id
            default_role
            active
            display_name
            customer_id
            email
            phone
            created_at
            updated_at
            avatar_url
            customer {
              name
            }
          }
        }
        defaultCustomer: users(where: {_and: [{ customer_id: { _in: $customerIds } }, {default_role: {_ilike: "%dealer%"}}]}) {
            id
            default_role
            active
            display_name
            customer_id
            email
            phone
            avatar_url
            created_at
            updated_at
            customer {
              name
            }
        }
      }
    `;

    let users = [];
    if (customerIds && customerIds.length > 0) {
      const usersRes = await _parent.gql.query(GET_USERS_BY_ORG, { customerIds });
      //Build array of users associated with each of the rooftops provided. 
      //This can be a combination of users associated with the rooftop directly and users associated with the rooftop through a userToCustomer relationship in their permissions
      if (usersRes && usersRes.data) {
        if (usersRes.data.defaultCustomer && usersRes.data.defaultCustomer.length > 0) {
          users = usersRes.data.defaultCustomer;
        }
        if (usersRes.data.userToCustomers && usersRes.data.userToCustomers.length > 0) {
          users = users.length > 0 ? users.concat(usersRes.data.userToCustomers.map(u => u.user)) : usersRes.data.userToCustomers.map(u => u.user);
        }
      }
    }
    if (users.length > 0) {
        //filter out duplicates
        users = users.filter((user, index, self) =>
            index === self.findIndex((t) => (
                t.id === user.id
            ))
        );
    }
    return users;
  },
};

module.exports = users;
